function getApiBase() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (!envUrl) return window.location.origin;

  try {
    const envHost = new URL(envUrl).hostname;
    const currentHost = window.location.hostname;
    // If running on a different domain than the build-time URL, use current origin
    // This handles production deployments where the env was set to preview URL
    if (envHost !== currentHost && currentHost !== 'localhost') {
      return window.location.origin;
    }
  } catch (e) {
    console.warn('Failed to parse REACT_APP_BACKEND_URL, using current origin:', e.message);
  }
  return envUrl;
}

export const API_BASE = getApiBase();
export const API = `${API_BASE}/api`;
